// $(document).ready(function(){
//   $('.Video_gallery_wrapper .svg-container').click(function(){
//     $(this).prev().children('iframe').src += "&autoplay";
//   });
// });

let iframes = document.querySelectorAll('iframe');

iframes.forEach(function (iframe) {
    if (iframe.src.includes('youtube')) {
        if (!iframe.src.includes('enablejsapi=1')) {
            iframe.src += (iframe.src.includes('?') ? '&' : '?') + 'enablejsapi=1';
        }

        iframe.classList.add("yt-video");
    }
});
const intersectionCallback = (entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      let elem = entry.target;

      if (entry.intersectionRatio < 0.4) {
        // If at least 60% of the element is hidden, stop the videos
        document.querySelectorAll('.yt-video').forEach(function (iframe) {
          iframe.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
        });
      }
    }
  });
};

const observer2 = new IntersectionObserver(intersectionCallback, { threshold: [0.1, 0.2, 0.3, 0.4] });

// Assuming you have target elements with the class "yt-video"
const targetElements = document.querySelectorAll('.yt-video');
targetElements.forEach((targetElement) => {
  observer2.observe(targetElement);
});



  jQuery(document).ready(function($){
$('.svg-container1').on('click', function() {
        var vidurl = $(this).find('.iframe_info').data('src');
        var vidtitle = $(this).find('.iframe_info').data('title');
        $('.yt-video').each(function(){
          this.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*')
        });
        $(this).html(
            '<iframe class="yt-video" width="100%" height="230" title="' + vidtitle +
            '" src="' + vidurl + '?autoplay=1&enablejsapi=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'
        );
        $(this).closest('.swiper-slide').find('img').hide();

        // Adjust the height of the iframe container
        $(this).find('iframe').css('height', '280');
    });

});
if($('.additional-icons')){
  $(document).on('click', '.additional-icons', function () {

  $('.yt-video').each(function(){
          this.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*')
        });
    
      $('.video-container').html(
          '<iframe class="yt-video" width="100%" height="230" src="https://www.youtube.com/embed/' + videoId + '?autoplay=1&enablejsapi=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'
      );
      $(this).closest('.video-container').find('img').hide();
  });
}

$("header-menu details" ).each(function(){
    $(this).mouseover(function() {
        $(this).attr("open","");
        $(this).child('summary').attr("aria-expanded", "true");
    })
    .mouseout(function() {
         $(this).removeAttr("open","");
        $(this).child('summary').removeAttr("aria-expanded", "true");
    });
});
var players = [];

function onYouTubeIframeAPIReady() {
  $('.yt-video').each(function(index, element) {
    var player = new YT.Player(element, {
      events: {
        'onStateChange': onPlayerStateChange
      }
    });
    players.push(player);
  });
}

function onPlayerStateChange(event) {
  if (event.data == YT.PlayerState.PLAYING) {
    var currentPlayer = event.target;
    pauseOtherPlayers(currentPlayer);
  }
}

function pauseOtherPlayers(currentPlayer) {
  for (var i = 0; i < players.length; i++) {
    var player = players[i];
    if (player !== currentPlayer) {
      player.pauseVideo();
    }
  }
}
